import { defaultRows } from "../../constants/rows";
import { IAction } from "../action";
import { actionTypes } from "../actions";
export function getLimitRowsTo(state, action) {
    if (state === void 0) { state = defaultRows.limit; }
    switch (action.type) {
        case actionTypes.loadScopeNames:
            if (action.payload) {
                return state;
            }
            return defaultRows.limit;
        case actionTypes.dataModelNamesLoaded:
            return defaultRows.limit;
        case actionTypes.changeLimitRowsTo:
            return action.payload;
        default:
            return state;
    }
}
